import createPadding from "./component-library207.mjs";
import stringSize from "./component-library208.mjs";
import toInteger from "./component-library209.mjs";
import toString from "./component-library206.mjs";
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);
  var strLength = length ? stringSize(string) : 0;
  return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
}
export {
  padStart as default
};
